/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedbeforeyes2Inputs */

const en__field_participatedbeforeyes2 = /** @type {(inputs: _Field_Participatedbeforeyes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const de__field_participatedbeforeyes2 = /** @type {(inputs: _Field_Participatedbeforeyes2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {_Field_Participatedbeforeyes2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedbeforeyes2 = /** @type {((inputs?: _Field_Participatedbeforeyes2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedbeforeyes2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_participatedbeforeyes2(inputs)
	return de__field_participatedbeforeyes2(inputs)
});
export { _field_participatedbeforeyes2 as "_field_participatedBeforeYes" }